const contactUsInitState = {
    contactUsData: {},
    message: '',
    careCardProgramData: {},
    listCareers: []
};

export default contactUsInitState;
